import React from 'react';
import Logo from './Logo';

type SparkVariant = 'hero' | 'mark' | 'watermark' | 'console';

interface CreationSparkProps {
  variant?: SparkVariant;
  className?: string;
}

const SRC = '/brand/hero-contact.png';

export default function CreationSpark({ variant = 'hero', className = '' }: CreationSparkProps) {
  if (variant === 'mark') {
    return <Logo className={className} />;
  }

  return (
    <div className={`contact-photo contact-photo-${variant} ${className}`} aria-hidden="true">
      <img src={SRC} alt="" className="contact-photo-img" />
    </div>
  );
}
